import m from 'mithril';
import {trans, has_permission} from "../helpers";

import Steps from './steps.js';

let challenge_state = require('../new_challenge_creator/challengeState.js');


window.state = challenge_state;

let copied_url = false;

let can_request_public_challenge = false;
let sending_public_challenge_request = false;
// let public_challenge_requested = false;

function get_type_id(code) {
    if (Object.keys(challenge_state.challenge_types_code_to_id) == 0)
        return null;

    return challenge_state.challenge_types_code_to_id[code];  
}

function request_public_challenge() {
    let confirm_message = trans('challenge.confirm_request_public_title') + '\n\n';
    confirm_message += trans('challenge.confirm_request_public_text');

    if (!confirm(confirm_message)) {
        return;
    }

    sending_public_challenge_request = true;

    let data = {
        id_challenge: challenge_state.id_challenge
    };

    m.request({
        method: "POST",
        url: "/api/challenge/request_public",
        body: data
    }).then(function(data) {
        sending_public_challenge_request = false;
        can_request_public_challenge = false;
        challenge_state.challenge.requested_public = true;

        m.redraw();
    });
}

class InviteToOrganizationsBox {
    view() {
        let organizations_str = challenge_state.challenge.organizations.list.map(o => o.title).join(', ');

        return m('.article-share.article-share--boxed', [
            m('.article-share__invite-firends-to-orgs', [
                m('div', trans('challenge.challenge_is_only_available_for_organizations_text') + ': ' + organizations_str + '.'),
                m('div', [
                    trans('challenge.invite_friends_to_organization_here_text') + ' ',
                    m('a.link', {href: SPORTNETXPAGE.SPORTNETXLINK + 'profile/userorganizations', target: '_blank'}, trans('common.here').toUpperCase())
                ]),
            ]),
            m('.article-share__copy-link', [
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('input', {
                                id: 'challengeUrl',
                                type: 'text',
                                value: SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                                readonly: true,
                                onclick: e => {
                                    let url_text = document.getElementById("challengeUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices
                                }
                            })
                        ]),
                        m('.line-element', [
                            m('.btn.btn--main.btn--transition' + (copied_url ? '.btn--green' : '.btn--main'), {
                                onclick: e => {
                                    let url_text = document.getElementById("challengeUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices

                                    document.execCommand("copy");

                                    url_text.setSelectionRange(0, 0);
                                    copied_url = true;
                                }
                            }, copied_url ? trans('common.copied')+'!' : trans('common.copy'))
                        ])
                    ])
                ])
            ]),

            (can_request_public_challenge) &&
            [
                (!sending_public_challenge_request) &&
                m('.btn.btn--main.btn--transition.btn--main', {
                    onclick: e => request_public_challenge()
                }, trans('challenge.request_public_challenge')),
                
                (sending_public_challenge_request) &&
                m('h3', trans('challenge.sending_public_request') + '...')
            ],

            (!can_request_public_challenge && challenge_state.challenge.requested_public == 1) &&
            m('h3', trans('challenge.public_challenge_requested'))
        ]);
    }
}

class PrivateShareBox {
    view() {
        return m('.article-share.article-share--boxed.article-share--one-line', [
            m('.article-share__copy-link', [
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('input', {
                                id: 'challengeUrl',
                                type: 'text',
                                value: SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                                readonly: true,
                                onclick: e => {
                                    let url_text = document.getElementById("challengeUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices
                                }
                            })
                        ]),
                        m('.line-element', [
                            m('.btn.btn--main.btn--transition' + (copied_url ? '.btn--green' : '.btn--main'), {
                                onclick: e => {
                                    let url_text = document.getElementById("challengeUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices

                                    document.execCommand("copy");

                                    url_text.setSelectionRange(0, 0);
                                    copied_url = true;
                                }
                            }, copied_url ? trans('common.copied')+'!' : trans('common.copy'))
                        ])
                    ])
                ])
            ]),
        ]);
    }
}

class ShareBox {
    view() {
        return m('.article-share.article-share--boxed', [
            m('p', trans('challenge.congratulations_msg')),
            m('.article-share__copy-link', [
                m('.ijf-form', [
                    m('.line', [
                        m('.line-element', [
                            m('input', {
                                id: 'challengeUrl',
                                type: 'text',
                                value: SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                                readonly: true,
                                onclick: e => {
                                    let url_text = document.getElementById("challengeUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices
                                }
                            })
                        ]),
                        m('.line-element', [
                            m('.btn.btn--main.btn--transition' + (copied_url ? '.btn--green' : '.btn--main'), {
                                onclick: e => {
                                    let url_text = document.getElementById("challengeUrl");

                                    url_text.select();
                                    url_text.setSelectionRange(0, 99999); // For mobile devices

                                    document.execCommand("copy");

                                    url_text.setSelectionRange(0, 0);
                                    copied_url = true;
                                }
                            }, copied_url ? trans('common.copied')+'!' : trans('common.copy'))
                        ])
                    ])
                ])
            ]),
            m('.article-share__icons', [
                m('a', { 
                    href: "https://www.facebook.com/sharer/sharer.php?u=" + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                    target: "_blank"
                }, [
                    m('div.article-share__icon.facebook--white'),
                    m('div.article-share__name', trans('common.share_facebook')),
                ]),
                m('a', { 
                    href: "https://twitter.com/home?status=" + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                    target: "_blank"
                }, [
                    m('div.article-share__icon.twitter--white'),
                    m('div.article-share__name', trans('common.share_twitter')),
                ]),
                m('a', { 
                    href: "mailto:friend@example.com?subject=Športni izziv&body= " + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                }, [
                    m('div.article-share__icon.email--white'),
                    m('div.article-share__name', trans('common.share_email')),
                ]),
                m('a', { 
                    href: "https://telegram.me/share/url?url=" + SPORTNETXPAGE.BASEURL + "/challenge/view/" + challenge_state.challenge.slug,
                    target: "_blank"
                }, [
                    m('div.article-share__icon.telegram--white'),
                    m('div.article-share__name', trans('common.share_telegram')),
                ]),
            ])
        ]);
    }
}

class ChallengeCreated {
    oninit() {
        // console.log(challenge_state);
        // get_challenge_types();

        if ((challenge_state.challenge.public == 1 || challenge_state.challenge.unlisted == 1) &&
            challenge_state.challenge.organizations.list.length > 0 &&
            challenge_state.challenge.requested_public == 0 &&
            !has_permission('challenges.canCreatePublic')) {
            can_request_public_challenge = true;
        }
    }

    challengeCreated() {
        return [
            m('h2.editor-title', trans('challenge.congratulations_title')),

            (
                (challenge_state.challenge.public == 1 || challenge_state.challenge.unlisted == 1) && 
                challenge_state.challenge.organizations.list.length == 0
            ) &&
            m(ShareBox),

            (
                (challenge_state.challenge.public == 1 || challenge_state.challenge.unlisted == 1) &&
                challenge_state.challenge.organizations.list.length > 0
            ) &&
            m(InviteToOrganizationsBox),

            (challenge_state.challenge.public == 0 && challenge_state.challenge.unlisted == 0) &&
            m(PrivateShareBox),

            m('br'),

            m('a.btn.btn--main', {
                href: '/challenge/view/' + challenge_state.challenge.slug,
            }, trans('common.view_challenge')),
        ]
    }

    challengeUpdated() {
        return [
            m('h2.editor-title', trans('challenge.successfuly_updated')),

            (
                (challenge_state.challenge.public == 1 || challenge_state.challenge.unlisted == 1) && 
                challenge_state.challenge.organizations.list.length == 0
            ) &&
            m(ShareBox),

            (
                (challenge_state.challenge.public == 1 || challenge_state.challenge.unlisted == 1) &&
                challenge_state.challenge.organizations.list.length > 0
            ) &&
            m(InviteToOrganizationsBox),

            (challenge_state.challenge.public == 0 && challenge_state.challenge.unlisted == 0) &&
            m(PrivateShareBox),

            m('br'),

            m('a.btn.btn--main', {
                href: '/myprofile/challenges',
            }, trans('challenge.back_to_profile')),
        ]
    }

    view() {
        if (challenge_state.mode == 'update') {
            return this.challengeUpdated();
        }
        
        return this.challengeCreated();
    }
}

export default ChallengeCreated;